import React from 'react';
import styles from './ProgressBar.module.scss';

function ProgressBar({ progress, classes, step, totalStep }) {
  return (
    <>
      <div className={`${styles.progressCustomisation} ${classes}`}>
        <div
          className={`${styles.progressCustomisationBar}`}
          role="progressbar"
          style={{ width: `${progress}%`, transition: '0.5s all' }}
        />
      </div>
      <span className={styles.steps}>{`${step} of ${totalStep}`}</span>
    </>
  );
}

export default ProgressBar;
